import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import Home from '../components/Home'
import WebcamCapture from '../components/WebcamCapture'
import Upload from '../components/Upload'
import Review from '../components/Review'
import Survey from '../components/Survey'
import Thanks from '../components/Thanks'
import { createSession, getConfig } from '../api'
import Loader from '../components/UI/Loader'
import Button from '../components/UI/Button'
import Title from '../components/UI/Title'
import { setWordings } from '../components/UI/T'
import { useInterval } from 'react-use'

function AutoHeight() {
  const [count, setCount] = useState(0)
  useInterval(() => setCount(count + 1), 4000)
  return (
    <style dangerouslySetInnerHTML={{ __html: `
      :root { --vh: ${((typeof window !== `undefined`) && window.innerHeight * 0.01)}px }
      html { font-size: ${((typeof window !== `undefined`) && (window.innerHeight < 800 && window.innerHeight < window.innerWidth) ? 80 : 100)}% }
    ` }} />
  )
}

export default function Root() {
  const [config, setConfig] = useState()
  const [session, setSession] = useState()
  const [saved, setSaved] = useState()

  useEffect(() => {
    getConfig().then(c => {
      setWordings(c.kabine_config.pages)
      setConfig(c)
    })
  }, [])
  if (!config) return <Loader />
  console.log(config)
  const start = type => setSession({ type })
  const setPhoto = photo => setSession({ ...session, photo })
  const retryPhoto = _ => setSession({ ...session, photo: null })
  const confirmPhoto = svg => setSession({ ...session, svg: svg.replace(/style="[^"]*"/, '') })
  const confirmAnswers = answers => {
    setSession({ ...session, answers })
    saveSession(answers)
  }
  const saveSession = answers => {
    setSaved(undefined)
    createSession(answers || session.answers, session.photo, session.svg, session.eventId).then(() => 
      setSaved(true)
    ).catch(e =>
      setSaved(false)
    )
  }
  const reset = () => setSession(null)
  // const bg = config.event_printing_templates.find(ept => ept.use_tag === 'assets').event_printing_template_images[0].url
  // const mascotte = config.event_printing_templates.find(ept => ept.use_tag === 'assets').event_printing_template_images[1].url
  const logo = config.event_printing_templates.find(ept => ept.use_tag === 'assets').event_printing_template_images[0].url
  // const logo2 = config.event_printing_templates.find(ept => ept.use_tag === 'assets').event_printing_template_images[2].url
  const colors = ['#faee75', '#000']
  console.log(config)
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Photobooth Digital</title>
        <meta property="og:title" content="Photobooth Digital" />
      </Helmet>
      <style dangerouslySetInnerHTML={{ __html: `
        body { background-color: #69a0d3 }
        .text-primary { color: ${colors[0]} }
        .text-secondary { color: ${colors[1]} }
        .text-blue { color: #19194b }
        .bg-primary { background-color: ${colors[0]} }
        .bg-secondary { background-color: ${colors[1]} }
        .bg-blue { background-color: #19194b }
        .border-primary { border-color: ${colors[0]} }
        .border-secondary { border-color: ${colors[1]} }
        .h-screen {height: calc(var(--vh, 1vh) * 100) !important}
        .min-h-screen {min-height: calc(var(--vh, 1vh) * 100) !important}
      ` }} />
      <AutoHeight />
      <div
        className="min-h-screen w-screen text-black pb-16 lg:pb-20" >
        {session && !(session.svg && session.answers === undefined) &&
          <div className="fixed h-10 lg:h-16 w-full left-0 bottom-0 pointer-events-none bg-contain bg-center bg-no-repeat mb-1 lg:mb-4 " style={{ zIndex: -1, backgroundImage: `url(${logo})` }} />
        }
        {!session &&
          <Home start={start} logo={logo} />
        }
        {session && !session.photo && session.type === 'upload' &&
          <Upload setPhoto={setPhoto} reset={reset} />
        }
        {session && !session.photo && session.type === 'photo' &&
          <WebcamCapture setPhoto={setPhoto} reset={reset} />
        }
        {session && session.photo && !session.svg &&
          <Review template={config.event_printing_templates.find(pt => pt.use_tag === 'classic')} photo={session.photo} confirm={confirmPhoto} retry={retryPhoto} />
        }
        {session && session.svg && session.answers === undefined &&
          <Survey questions={config.survey_questions.filter(q => q.active)} confirmAnswers={confirmAnswers} />
        }
        {session && session.answers !== undefined &&
          <Thanks saved={saved} saveSession={saveSession} />
        }
      </div>
    </>
  )
}
